// The online series' Register Now (the banner's and /2026's, 2026-10-14): which event it opens
// #register for, its wording, and whether there's anything left to register for.

import {computed} from "vue";
import useOnlineSessions from "@/composables/useOnlineSessions";
import useEventRegistration from "@/composables/useEventRegistration";
import usePendingInvoice from "@/composables/usePendingInvoice";

export default function useOnlineRegisterButton() {
  const {upcomingEventKeys, year} = useOnlineSessions();
  const {isRegisteredOnline, isReservedOnline} = useEventRegistration(year);
  const {hasPendingInvoice} = usePendingInvoice();
  // one upcoming event left to register for: it (#register selects only it, e.g. the Workshop
  // once the Masterclass is past); several: "" (#register selects them all)
  const unregisteredEventKey = computed(() => {
    const open = upcomingEventKeys.value.filter((key) => !isRegisteredOnline(key));
    return open.length === 1 ? open[0] : "";
  });
  // a bank-transfer invoice waiting for payment: Pay Now (#register opens at the invoice);
  // 2-for-1: a colleague paid for the viewer's place, so #register asks only for their details
  const registerLabel = computed(() => {
    if (hasPendingInvoice.value) return "Pay Now";
    const hasReservation = upcomingEventKeys.value.some((key) => isReservedOnline(key));
    return hasReservation ? "Complete Registration" : "Register Now";
  });
  // registered for every upcoming event: nothing left to register for (the banner counts down)
  const isRegisteredForAll = computed(() => {
    const keys = upcomingEventKeys.value;
    return keys.length > 0 && keys.every((key) => isRegisteredOnline(key));
  });
  return {unregisteredEventKey, registerLabel, isRegisteredForAll};
}
